<section class="profile-support">

    <app-profile-section-header title="Atención al cliente" subtitle="Estamos aquí para ayudarte">
        <svg headerIcon viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">
            <path d="M4 14v-2a8 8 0 0 1 16 0v2" stroke-linecap="round"/>
            <path d="M4 14h3v6H5a1 1 0 0 1-1-1v-5zM20 14h-3v6h2a1 1 0 0 0 1-1v-5z" stroke-linejoin="round"/>
        </svg>
    </app-profile-section-header>

    <div class="ps-field">
        <label>Selecciona un producto</label>
        <div class="ps-select" [class.ps-select--open]="open">
            <button type="button" class="ps-select-trigger" (click)="toggleDropdown()" [attr.aria-expanded]="open">
                <span>{{ selected?.label }}</span>
                <svg class="ps-select-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                    <path d="M6 9l6 6 6-6" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <ul *ngIf="open" class="ps-select-list" role="listbox">
                <li *ngFor="let p of products" role="option"
                    [class.active]="p.code === selected?.code" (click)="select(p)">
                    {{ p.label }}
                </li>
            </ul>
        </div>
    </div>

    <div class="ps-contact">
        <div class="ps-contact-phone">
            <span class="ps-contact-icon">
                <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                    <path d="M22 21.5a17 17 0 0 1-11.5-11.5l2-3-3-4-4 1c0 11 7 18 18 18l1-4-4-3-2.5 1.5z" stroke-linejoin="round"/>
                </svg>
            </span>
            <div class="ps-contact-text">
                <span class="ps-contact-label">Por teléfono</span>
                <strong class="ps-contact-value">900 828 200</strong>
            </div>
        </div>
        <div class="ps-contact-right">
            <p class="ps-contact-note">Llámanos para abrir un expediente, consultar el estado de uno en curso o hacer una consulta legal.</p>
            <div class="ps-contact-hours">
                <span class="ps-contact-label">Horario</span>
                <strong class="ps-contact-value">De Lunes a Viernes de 9:00h a 20:00h</strong>
            </div>
        </div>
    </div>

    <div class="ps-legal-support" *ngIf="isLegalAssistanceSelected()">
        <div class="ps-contact">
            <div class="ps-contact-phone">
                <span class="ps-contact-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                        <path d="M21 12c0 4.418-4.03 8-9 8-1.21 0-2.36-.213-3.41-.6L3 21l1.62-4.32C3.6 15.18 3 13.65 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" stroke-linecap="round" stroke-linejoin="round"/>
                        <line x1="8" y1="11" x2="16" y2="11" stroke-linecap="round"/>
                        <line x1="8" y1="14" x2="13" y2="14" stroke-linecap="round"/>
                    </svg>
                </span>
                <div class="ps-contact-text">
                    <span class="ps-contact-label">Por chat</span>
                    <button type="button" class="ps-legal-chat-btn" (click)="openChat()">Iniciar chat</button>
                </div>
            </div>
            <div class="ps-contact-right">
                <p class="ps-contact-note">También puedes escribirnos por chat.</p>
                <div class="ps-contact-hours">
                    <span class="ps-contact-label">Horario</span>
                    <strong class="ps-contact-value">De Lunes a Viernes de 9:00h a 18:00h</strong>
                </div>
            </div>
        </div>

        <div class="ps-legal-card">
            <h3>¿Necesitas ayuda legal urgente?</h3>
            <p>Si necesitas <b>asesoramiento jurídico urgente fuera del horario habitual</b>, llámanos al <strong>900 052 232</strong>.</p>
            <p>Disponible las 24 horas, todos los días del año.</p>
        </div>
    </div>

    <section class="ps-mediator">
        <h3 class="ps-mediator-title">Tu mediador</h3>

        <div class="ps-mediator-info" *ngIf="selected">
            <div class="ps-info-cell">
                <span class="ps-info-label">Nombre</span>
                <span class="ps-info-value">{{ selected.name }}</span>
            </div>
            <div class="ps-info-cell">
                <span class="ps-info-label">Teléfono</span>
                <span class="ps-info-value">{{ selected.phone }}</span>
            </div>
            <div class="ps-info-cell" *ngIf="undefined != selected.phone2">
                <span class="ps-info-label">Teléfono</span>
                <span class="ps-info-value">{{ selected.phone2 }}</span>
            </div>
            <div class="ps-info-cell">
                <span class="ps-info-label">Email</span>
                <span class="ps-info-value">{{ selected.email }}</span>
            </div>
        </div>
    </section>

</section>
